import { EndDepartureDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** "Abfahrt beenden" — closes the departure phase and releases the work session. */
export function useEndTaskDeparture() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: EndDepartureDto }) =>
      taskApi.endDeparture(id, dto).then((r) => r.data),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(vars.id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      // Closing the departure re-derives the occupied block (actual departure wins).
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
